import React from "react";

const BurgerMenuIcon = ({ width, height, itemHeight, color = "#000" }) => {
  return (
    <div
      className="flex flex-col gap-1 relative items-center justify-center"
      style={{ width, height }}
    >
      <div style={{ width: "100%", height: itemHeight, background: color, borderRadius: "5px" }} />
      <div style={{ width: "100%", height: itemHeight, background: color, borderRadius: "5px" }} />
      <div style={{ width: "100%", height: itemHeight, background: color, borderRadius: "5px" }} />
    </div>
  );
};

export default BurgerMenuIcon;
